// src/components/EwiChat.jsx
import React, { useState, useEffect } from "react";
import { useEwiChat } from "../../hooks/useEwiChat";
import Sidebar from "./Sidebar";
import ChatArea from "./ChatArea";
import DeleteConfirmModal from "./DeleteConfirmModal";

export default function EwiChat() {
  const {
    sessions,
    currentSession,
    messages,
    isLoading,
    error,
    fetchSessions,
    updateSessionName,
    deleteSession,
    selectSession,
    startNewChat,
    fetchSessionMessages,
    sendMessage,
  } = useEwiChat();

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    session: null,
  });
  const [editingSession, setEditingSession] = useState(null);

  // 초기 로드
  useEffect(() => {
    fetchSessions();
  }, [fetchSessions]);

  // 세션 이름 수정 핸들러
  const handleUpdateSession = async (sessionId, newName) => {
    const result = await updateSessionName(sessionId, newName);
    if (result.ok) {
      setEditingSession(null);
    }
    return result;
  };

  // 세션 삭제 핸들러
  const handleDeleteSession = async () => {
    if (!deleteModal.session) return;

    const result = await deleteSession(deleteModal.session.id);
    if (result.ok) {
      setDeleteModal({ open: false, session: null });
    }
  };

  // 더 많은 메시지 로드
  const handleLoadMore = async () => {
    if (!currentSession || !messages || messages.length === 0) return;

    const oldestMessage = messages[0];
    if (oldestMessage?.id) {
      await fetchSessionMessages(currentSession.id, oldestMessage.id);
    }
  };

  return (
    <>
      <div className="flex h-screen bg-white">
        {/* 사이드바 */}
        <Sidebar
          isOpen={isSidebarOpen}
          sessions={sessions}
          currentSession={currentSession}
          editingSession={editingSession}
          onToggle={() => setIsSidebarOpen(!isSidebarOpen)}
          onNewChat={startNewChat}
          onSelectSession={selectSession}
          onEditSession={setEditingSession}
          onUpdateSession={handleUpdateSession}
          onDeleteSession={(session) => setDeleteModal({ open: true, session })}
        />

        {/* 채팅 영역 */}
        <ChatArea
          messages={messages}
          currentSession={currentSession}
          isLoading={isLoading}
          error={error}
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          onSendMessage={sendMessage}
          onLoadMore={handleLoadMore}
        />

        {/* 삭제 확인 모달 */}
        <DeleteConfirmModal
          isOpen={deleteModal.open}
          session={deleteModal.session}
          onConfirm={handleDeleteSession}
          onCancel={() => setDeleteModal({ open: false, session: null })}
        />
      </div>
    </>
  );
}
